(() => {
    const homepageImagesContainers = document.querySelectorAll(
        '[data-homepage-images-container]',
    );

    homepageImagesContainers.forEach(homepageImagesContainer => {
        const images = Array.from(
            homepageImagesContainer.querySelectorAll('img'),
        );

        const update = () => {
            const activeImageIndex = images.findIndex(image =>
                image.classList.contains('is-active'),
            );

            // eslint-disable-next-line max-len
            const nextActiveImageIndex =
                activeImageIndex < images.length - 1 ? activeImageIndex + 1 : 0;

            images.forEach((image, index) => {
                if (index === nextActiveImageIndex) {
                    image.classList.add('is-active');
                } else {
                    image.classList.remove('is-active');
                }
            });

            setTimeout(update, 4000);
        };

        setTimeout(update, 4000);
    });
})();
